<div class="row">
    <div class="col-md-12 card  pb-2 mt-3">
        <h2>BOM Explorer</h2>
        <app-select-bom></app-select-bom>
        <hr>
    </div>
</div>
